import { HttpErrorResponse } from '@angular/common/http';

export class DataLayer {
  pageInfo: PageInfo;
  userInfo: UserInfo;
  rule: string;
  custom?: any;
}

export class PageInfo {
  pageName: string;
  siteSection: string;
  ambiente: string;
  url?: string;
}

export class UserInfo {
  racf: string;
  authenticationMethod: string;
  businessId: string;
  clientId: string;
  userId: string;
  serviceId: string;
  deviceID: string;
  monitoringCenter?: boolean;
  cnpjFull: string;
  cnpjBase: string;
  contracts: UserInfoContracts[];
  cnae: UserInfoCnae[];
  companySize: UserInfoCnae;
  channel: UserInfoChannel;
  segment: string;
  products: UserInfoProducts[];
  numberOfActiveContract: number;
  numberOfUsers : number;
  debt: UserInfoDebt;
  dataEV: UserInfoDataEV;
  vcmDiscount: UserInfoVcmDiscount[];
  offers: UserInfoCnae[];
  dataContact: UserInfoDataContact[];
  distributorData: UserInfoDistributor;
  dataMainContact: UserInfoDistributor;
  errors?: UserInfoError[];
}

export class UserInfoContracts {
  contractNumber: string;
  contractDescription: string;
  contractDataBase: string;
  contractSisNumber: string;
  vcmValue: number;
  vcm: UserInfoVcm;
}

export class UserInfoCnae {
  id: string;
  description: string;
}

export class UserInfoChannel {
  classification: string;
  sector: string;
}

export class UserInfoProducts {
  productId: string;
  name: string;
  description: string;
  initials: string;
  url: string;
  principal: boolean;
  categories: UserInfoProductsCategories[];
  userProductDetail: UserInfoProductsUser;
}

export class UserInfoProductsCategories {
  code: string;
  name: string;
}

export class UserInfoProductsUser {
  userProductDetailsId: string;
  favorite: boolean;
  hasPermission: boolean;
}

export class UserInfoDebt {
  count: number;
  totalValue: number;
}

export class UserInfoDataEV {
  name: string;
  phoneNumber: string;
  email: string;
  photo: string;
}

export class UserInfoVcm {
  manyContractsByInvoice: boolean;
  financialDemonstrative: UserInfoVcmFinancial[];
}

export class UserInfoVcmFinancial {
  month: number;
  year: number;
  value: number;
  vcm: number;
}

export class UserInfoVcmDiscount {
  id: string;
  description: string;
  inclusionDate: string;
  penaltyData: UserInfoVcmDiscountPenalty;
  gracePeriod: UserInfoVcmDiscountGrace;
}

export class UserInfoVcmDiscountPenalty {
  vcmPercent: number;
  days: number;
  fixedValue: number;
}

export class UserInfoVcmDiscountGrace {
  startDate: string;
  endDate: string;
}

export class UserInfoDistributor {
  name: string;
}

export class UserInfoDataContact {
  id: string;
  fullName: string;
  document: UserInfoContactDocument;
  birthDate: string;
  email: UserInfoContactEmail;
  mobile: UserInfoContactMobile;
}

export class UserInfoContactDocument {
  documentId: string;
  documentCountry: string;
}

export class UserInfoContactEmail {
  email: string;
  validatedStatus: string;
}

export class UserInfoContactMobile {
  regionCode: number;
  areaCode: number;
  phoneNumber: number;
}

export class UserInfoError {
  code: number;
  field: string;
}

export interface ModalErrorAnalytics {
  error: HttpErrorResponse;
  method: string;
}
